import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';

import BasicModal from 'components/Modal';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';
import Autocomplete from 'admin/components/atoms/AutoComplete';
import { baseURL } from 'utils/api';

const EditForm = ({
    show,
    unShow,
    offerId,
    type,
    handelRefresh,
    setShowTerm,
    handleActivateOffer,
    fetchData,
    isActive,
    allLocations, values, setValues,getLocationData
}) => {
    const [loading, setLoading] = useState(false);


    const validateForm = () => {
        if (values.locations.length === 0) {
            toast.error('Please select locations');
            return false;
        }

        if (!parseInt(values.estimatedSaving) || parseInt(values.estimatedSaving) <= 0) {
            toast.error('Estimated saving must be greater than 0');
            return false;
        }

        if (!values.pin || !/^\d{4}$/.test(values.pin)) {
            toast.error('Please enter a valid 4-digit pin');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const validLocationIds = values.locations
        // .map((loc) => allLocations.find((a) => a.id === loc.id))
        // .filter(Boolean)
        // .map((loc) => loc.id);

        try {
            setLoading(true);

            const response = await fetch(`${baseURL}update/offer/template/${offerId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    businessUserId: localStorage.getItem('id'),
                    passcode: values.pin,
                    savingPoints: parseInt(values.estimatedSaving),
                    businessLocations: validLocationIds,
                }),
            });

            const data = await response.json();

            if (data.success) {
                toast.success('Updated Successfully');
                handelRefresh();
                unShow();
                if(!isActive){
                    handleActivateOffer(offerId);
                }else{
                    fetchData()

                }
            } else {
                toast.error(data.message || 'Update failed');
            }
        } catch (err) {
            toast.error(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (key) => (e) => {
        const value = e.target.value;

        if (key === 'pin') {
            if (/^\d{0,4}$/.test(value)) {
                setValues((prev) => ({ ...prev, pin: value }));
            }
        } else if (key === 'estimatedSaving') {
            if (value === '' || Number(value) > 0) {
                setValues((prev) => ({ ...prev, estimatedSaving: value }));
            }
        }
    };

    return (
        <BasicModal show={show} unShow={unShow}>
            <form onSubmit={handleSubmit}>
                <SoftBox mb={2}>
                    <SoftTypography variant="caption">Locations *</SoftTypography>
                    <Autocomplete
                        label="Locations *"
                        placeholder="Select Locations"
                        value={allLocations.filter((item) => values?.locations?.includes(item.id))}
                        onChange={(e, selectedOptions) =>
                            setValues((prev) => ({
                                ...prev,
                                locations: selectedOptions.map((item) => item?.id),
                            }))
                        }
                        onInputChange={(value) => {
                            getLocationData(value); 
                        }}
                        options={allLocations}
                        getOptionLabel={(option) => option?.name || option?.label || 'Unnamed'} // Customize as per your data
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        multiple
                        required
                    />
                </SoftBox>

                <SoftBox mb={2}>
                    <SoftTypography variant="caption">Pin *</SoftTypography>
                    <SoftInput
                        value={values.pin}
                        onChange={handleChange('pin')}
                        name="pin"
                        placeholder="Enter 4-digit Pin"
                        type="text"
                        inputProps={{ maxLength: 4, pattern: "\\d{4}" }}
                        required
                    />
                </SoftBox>

                <SoftBox mb={2}>
                    <SoftTypography variant="caption">Estimated Saving (Round to next $) *</SoftTypography>
                    <SoftInput
                        value={values.estimatedSaving}
                        onChange={handleChange('estimatedSaving')}
                        name="estimatedSaving"
                        placeholder="Enter estimated saving"
                        type="text"
                        required
                    />
                </SoftBox>

                <SoftBox mt={4} display="flex" justifyContent="space-between" gap={2}>
                    <SoftButton variant="outlined" color="info" onClick={() => unShow(false)} fullWidth>
                        Cancel
                    </SoftButton>
                    <SoftButton
                        variant="gradient"
                        color="info"
                        type="submit"
                        fullWidth
                        disabled={loading}
                        sx={{ color: 'white' }}
                    >
                        {loading ? 'Saving...' : 'Save Changes'}
                    </SoftButton>
                </SoftBox>
            </form>
        </BasicModal>
    );
};

export default EditForm;
